import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-48 relative my-2" }
const _hoisted_2 = { class: "-translate-y-10 transform" }
const _hoisted_3 = { class: "text-gray-700 text-center text-sm" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DonutChart = _resolveComponent("DonutChart")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DonutChart, {
      data: _ctx.chartData,
      options: _ctx.chartOptions
    }, null, 8, ["data", "options"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("p", {
        style: `color: ${_ctx.color}`,
        class: "text-3xl font-bold text-center"
      }, _toDisplayString(_ctx.percentage) + "% ", 5),
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1)
    ])
  ]))
}